import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import DataAdapterOptionsView, {DataAdapterOptionsViewDerivates} from "../DataAdapterOptionsView";
import Button from "../../../components/Button";
import Dialog from "../../../components/Dialogs/Dialog";
import {TypefamilyDto, ModelyearDto, ModeltypeBasicDto, WorkflowStatusDtoType, AssignedModeltypeBasicDto} from "../../../services/Client";
import {Table, Icon, Dropdown} from "semantic-ui-react";
import {
    TDerivateIconProps,
    DerivateUtils,
    DerivateAssignmentUpdateTypes,
    DerivateDraftAssignmentUpdateTypes} from "../../../components/Table/components/derivate/DerivateUtils";
import {EOptionState} from "../../../components/DerivateOptionBar";
import Collapsible from "react-collapsible";
import _ from "lodash";

interface IModeltypeBasicAssignmentsDialogProps extends ITranslatedComponent {

    /** Dialog title */
    title: string;

    /** Dialog text */
    dialogText: string;

    /** Dialog text */
    isDraftAssignmentsOnly?: boolean;

    /** The option's typefamily */
    typefamily: TypefamilyDto;

    /** The option's modelyear */
    modelyear: ModelyearDto;

    /** A list of derivates that cannot be assigned to the option */
    unavailableDerivates: {[key: number]: String[]};

    /** Contains all the available derivates */
    derivates: ModeltypeBasicDto[];

    /** Derivates mapped as unique identifier */
    derivatesMap: DataAdapterOptionsViewDerivates;

    /** Contains the option's assignments(only for update) */
    existingAssignments?: DataAdapterOptionsView;

    workflowStatus?: string;

    /** Called when the user clicks on the confirm button */
    onConfirm(data: DataAdapterOptionsView): void;

    /** Called when the user clicks on the cancel button */
    onCancel(): void;
    pdipDerivates:AssignedModeltypeBasicDto[];
}

interface IModeltypeBasicAssignmentsDialogState {
    assignments: any;
    isConfirmedPdipTakeOver:boolean;
}

class ModeltypeBasicAssignmentsDialog extends React.Component<IModeltypeBasicAssignmentsDialogProps, IModeltypeBasicAssignmentsDialogState> {
    constructor(props: IModeltypeBasicAssignmentsDialogProps) {
        super(props);

        this.state = {
            assignments: {},
            isConfirmedPdipTakeOver : false
        };
    }

    componentDidMount() {
        this.setState({
            assignments: this.props.existingAssignments ? {...this.props.existingAssignments} : {}
        });
    }

    private handleChange(newValue: any, newValueKey: string) {
        if (newValue || _.isEqual(newValue, EOptionState.NotAvailable)) {
            let newAssignmentsValue = _.cloneDeep(this.state.assignments);
            if (Object.keys(newAssignmentsValue).find((key) => key === newValueKey) && _.isEqual(newValue, EOptionState.NotAvailable)) {
                delete newAssignmentsValue[newValueKey];
            } else {
                newAssignmentsValue[newValueKey] = newValue;
            }

            this.setState({assignments: newAssignmentsValue});
        }
    }

    private handleConfirm = () => {
        this.props.onConfirm(this.state.assignments);
    }

    render() {
        const {
            t,
            title,
            dialogText,
            isDraftAssignmentsOnly,
            modelyear,
            typefamily,
            unavailableDerivates,
            derivates,
            derivatesMap,
            workflowStatus,
            pdipDerivates
        } = this.props;
        const {assignments} = this.state;
        let labelPDIPButton;
        if(workflowStatus !== WorkflowStatusDtoType.MAINTENANCE) {
            labelPDIPButton=t('OPTIONS_VIEW:PDIP_OPTION_STATUS');
        }
        const actions = [
            (
                <Button
                    key={"submitButton"}
                    icon={"checkmark"}
                    onClick={this.handleConfirm}
                />
            ), (
                <Button
                    key={"cancelButton"}
                    icon={"ban"}
                    onClick={() => this.props.onCancel()}
                />
            )
        ];

        return (
            <Dialog
                title={title}
                open={true}
                actions={actions}
                fullWidth={false}
                customStyleClassName={"scrollableYDialog"}
            >
                <>
                    <Button
                        key={"submitButton"}
                        label="PDIP"
                        disabled={workflowStatus !== WorkflowStatusDtoType.MAINTENANCE}
                        className="pdip__btn"
                        onClick={() => this.setState({ isConfirmedPdipTakeOver: true })}
                    />
                        {labelPDIPButton && <p className="pdip__btn_p">{labelPDIPButton}</p>}
                        {derivates.length > 0 ?
                            <>
                                <span>{dialogText}</span>
                                <Table definition={true}>

                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell />
                                            <Table.Cell><strong>Current assignment</strong></Table.Cell>
                                            <Table.Cell><strong>PDIP assignment</strong></Table.Cell>
                                        </Table.Row>
                                        {derivates.map((value: ModeltypeBasicDto) => {
                                            const key = value.objectId;
                                            let assignmentType = assignments[key] ? assignments[key] : 0;
                                            const derivateIconProps: TDerivateIconProps | undefined = unavailableDerivates[key] ?
                                                undefined :
                                                DerivateUtils.getDerivateAssignmentIconProps(assignmentType);

                                            let typesDataSource = isDraftAssignmentsOnly
                                                ? [...DerivateDraftAssignmentUpdateTypes] : [...DerivateAssignmentUpdateTypes];

                                            if (typesDataSource.indexOf(assignmentType) === -1) {
                                                typesDataSource.push(assignmentType);
                                            }

                                            const getPdipDerivate = pdipDerivates.find(p => p.modeltypeBasic.objectId === key);
                                            let pdipDerivateIconProps: TDerivateIconProps | undefined;
                                            let derivateRenderName;
                                            if (getPdipDerivate) {
                                                const types = [];
                                                const eoptionState = DataAdapterOptionsView.getOptionState(getPdipDerivate.assignmentType);
                                                pdipDerivateIconProps = DerivateUtils.getDerivateAssignmentIconProps(eoptionState);
                                                types.push(eoptionState);
                                                derivateRenderName = DerivateUtils.getDerivateRenderDataSource(types);
                                                if (typesDataSource.indexOf(eoptionState) === -1 && workflowStatus === WorkflowStatusDtoType.MAINTENANCE) {
                                                    typesDataSource.push(eoptionState);
                                                }
                                                if(this.state.isConfirmedPdipTakeOver && workflowStatus === WorkflowStatusDtoType.MAINTENANCE) {
                                                    assignmentType = eoptionState;
                                                    this.state.assignments[key] = eoptionState;
                                                }
                                            }
                                            const derivateRenderDataSource = DerivateUtils.getDerivateRenderDataSource(typesDataSource);
                                            return (
                                                <Table.Row key={key}>
                                                    <Table.Cell>
                                                        {derivatesMap[key]}
                                                    </Table.Cell>
                                                    <Table.Cell>

                                                        {
                                                            unavailableDerivates[key] ?
                                                                <Collapsible
                                                                    open={true}
                                                                    trigger={<> <Icon name={"angle double down"} /> {t("OPTIONS_VIEW:SHOW_DERIVATES_DETAILS")} </>}
                                                                    triggerWhenOpen={<> <Icon name={"angle double up"} /> {t("OPTIONS_VIEW:HIDE_DERIVATES_DETAILS")} </>}
                                                                >
                                                                    <>
                                                                        {
                                                                            <ul>
                                                                                {
                                                                                    unavailableDerivates[key].map((cnr: String) => {
                                                                                        return (
                                                                                            <li key={key + '-' + cnr} className={"bold"}>
                                                                                                {
                                                                                                    `
                                                                                    ${t("OPTIONS_VIEW:MODELYEAR")}: ${modelyear.mj1}(${modelyear.mj4}) ->
                                                                                    ${t("OPTIONS_VIEW:TYPEFAMILY")}: ${typefamily.name} ->
                                                                                    ${t("OPTIONS_VIEW:CNR")}: ${cnr}
                                                                                    `
                                                                                                }
                                                                                            </li>
                                                                                        );
                                                                                    }
                                                                                    )
                                                                                }
                                                                            </ul>
                                                                        }
                                                                    </>
                                                                </Collapsible>
                                                                : assignments[derivatesMap[key]] === EOptionState.StandardV ?
                                                                    derivateIconProps &&
                                                                    <div>
                                                                        <Icon
                                                                            className={"float--left"}
                                                                            name={derivateIconProps.name}
                                                                            size={'large'}
                                                                            color={derivateIconProps.color}
                                                                        />
                                                                        {'(' + t("OPTIONS_VIEW:" + DataAdapterOptionsView.getAssigment(EOptionState.StandardV).toString()) + ')'}
                                                                    </div>
                                                                    :
                                                                    <Dropdown
                                                                        fluid={true}
                                                                        icon={derivateIconProps && <Icon
                                                                            className={derivateIconProps.name === "close" ? "invisible" : "float--left"}
                                                                            name={derivateIconProps.name}
                                                                            size={derivateIconProps.size === "small" ? "tiny" : "small"}
                                                                            color={derivateIconProps.color}
                                                                        />}
                                                                        selection={true}
                                                                        disabled={!!(unavailableDerivates && unavailableDerivates[key]
                                                                            || (workflowStatus === WorkflowStatusDtoType.APPROVED
                                                                                && ![EOptionState.OptionalDraft, EOptionState.AvailableDraft,
                                                                                EOptionState.StandardDraft, EOptionState.NotAvailable].includes(assignmentType)))}
                                                                        value={assignmentType}
                                                                        options={derivateRenderDataSource}
                                                                        onChange={(e, v) => this.handleChange(v.value, key.toString())}
                                                                    />
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {
                                                            pdipDerivateIconProps && derivateRenderName && <>
                                                                <Icon
                                                                    className={"float--left"}
                                                                    name={pdipDerivateIconProps.name}
                                                                    size={'large'}
                                                                    color={pdipDerivateIconProps.color}
                                                                />
                                                                <sup className={"font-weight--bold"} style={{ color: pdipDerivateIconProps.color }}>
                                                                    {pdipDerivateIconProps.supIconValue}
                                                                </sup>
                                                            </>

                                                        }
                                                    </Table.Cell>
                                                </Table.Row>
                                            );
                                        })
                                        }
                                    </Table.Body>
                                </Table>
                            </>
                            : t("OPTIONS_VIEW:EMPTY_DERIVATE_LIST_ASSIGNMENT")
                        }
                    </>

            </Dialog>
        );
    }
}

export default translate(["OPTIONS_VIEW", "COLUMN_FACTORY"])(ModeltypeBasicAssignmentsDialog);



// WEBPACK FOOTER //
// ./src/views/OptionsView/ModeltypeBasicAssignmentsDialog/ModeltypeBasicAssignmentsDialog.tsx